import { render, staticRenderFns } from "./penPosture.vue?vue&type=template&id=62a0c3ba&scoped=true&"
import script from "./penPosture.vue?vue&type=script&lang=js&"
export * from "./penPosture.vue?vue&type=script&lang=js&"
import style0 from "./penPosture.vue?vue&type=style&index=0&id=62a0c3ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0c3ba",
  null
  
)

export default component.exports